import React from 'react';

import WaveformBarGroup from 'js/src/components/app/waveform/WaveformBarGroup';
import type { ImmutableWaveformData } from 'js/src/data/media';

type WaveformImagePresentationProps = {
    waveformData: ImmutableWaveformData;
    width: number;
    height: number;
    fillPercentage: number;
};

const WaveformImagePresentation = ({
    waveformData,
    width,
    height,
    fillPercentage,
}: WaveformImagePresentationProps) => {
    return (
        <svg width={width} height={height}>
            <WaveformBarGroup
                svgWidth={width}
                svgHeight={height}
                waveformData={waveformData}
                fillPercentage={fillPercentage}
            />
        </svg>
    );
};

const WaveformImageMemoized = React.memo(WaveformImagePresentation);
const WaveformImage = WaveformImageMemoized;

export default WaveformImage;
